<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" ref="mapForm">
        <el-form-item label="合作方式" required>
          <el-radio-group v-model="form.manage_role">
            <el-radio
              :label="item.value"
              v-for="(item, i) in coopType"
              :key="i"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="合作门店" required v-if="form.id">
          {{temp.mechanism.mechanism_name}}
        </el-form-item>
         <el-form-item label="合作门店" required v-else>
          <mechanism-select :condition="{is_union:true}" :mecid.sync="form.mechanism_id"></mechanism-select>
        </el-form-item>
        <el-form-item label="合作时间" required>
          <el-date-picker
            v-model="form.start_time"
            value-format="yyyy-MM-dd 00:00:00"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-date-picker
            v-model="form.end_time"
            value-format="yyyy-MM-dd 23:59:59"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="合作类目" required v-if="form.type == 3">
          <el-select
            v-model="change_categories"
            multiple
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in categories"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="支付金额" v-permission="'setPromoterPrice'">
          <el-input v-model="form.pay_amount"></el-input>
           <p>
            不填为合作默认金额，填写后对方仅需支付填写的金额
          </p>
        </el-form-item>
       
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { ObjectChangedValue } from "@/js/utils";
import { coopType } from "../dict";
export default {
  data() {
    return {
      coopType,
      form: {},
      temp: {},
      change_categories: [],
      addServiceDialog: false,
      categories: "",
      admin_id: "",
      adminInfo: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.admin_id = this.$route.query.id;
    // this.getCategories();
  },
  methods: {
    getCategories() {
      this.$get("user/mechanismCategory/queryListPageChild", {
        status: 2,
        type: 2,
        source: "课程",
      }).then((res) => {
        this.categories = res.data.data;
      });
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    check() {
      if(!this.form.mechanism_id){
          this.$message('请选择机构')
          return false
      }
      if(!this.form.end_time){
          this.$message('请选择截至日期')
          return false
      }

      return true
    },
    updateForm() {
      
      this.updateServie();
    },
    submitForm() {
      if (this.check()) {
        this.addNew();
      }
    },

    addNew() {
      let url = "/user/adminMec/bindEnroll";
      let data = {
        handle_id: this.adminInfo.id,
        handle_name: this.adminInfo.name,
        admin_id: this.admin_id,
        ...this.form,
      };

      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      data.admin_id = this.admin_id
      let url = "/user/coachUnionPartnership/upPartnerType";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>